import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

interface IErrorMessageComponentProps {
    message: string;
    isHtml?: boolean;
};

const ErrorMessageComponent = (props: IErrorMessageComponentProps) => {
    return (
        (props.message !== '') ? (
            <MessageBar 
                messageBarType={MessageBarType.error}
                styles={{
                    root: {
                        marginTop: '10px',
                        marginBottom: '10px',
                    },
                }}>
                {
                    props.isHtml ? (
                        <div dangerouslySetInnerHTML={{ __html: props.message }}></div>
                    ) : (
                        props.message
                    )
                }
            </MessageBar>
        ) : (
             null
        )
    );
};

export default ErrorMessageComponent;
